<template>
  <div class="PlanDetails">
    <div
      class="plan-details-container"
      v-loading="is_subscribed_plan_details_loading"
    >
      <el-row
        v-if="
          (Object.keys(getSubscribedPlanDetails).length &&
            getSubscribedPlanDetails.plan == 'Premium') ||
            getSubscribedPlanDetails.plan == 'Pro'
        "
      >
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="
            websiteUserType.userType != 'broker' &&
            getSubscribedPlanDetails.access_code.length
              ? 19
              : 24
          "
          :xl="
            websiteUserType.userType != 'broker' &&
            getSubscribedPlanDetails.access_code.length
              ? 19
              : 24
          "
        >
          <el-card
            class="box-card pro-card"
            style="border-radius: 10px 10px 0px 0px !important"
          >
            <div>
              <div class="flex-space-between">
                <div>
                  <span
                    class="label-xs-bold"
                    style="color: #ffff; font-weight: 600; margin-right: 5px"
                    >Subscribed Plan</span
                  >
                  <span
                    ><img
                      src="../assets/images/Subscribed plan Icon.svg"
                      alt=""
                  /></span>
                  &nbsp;
                  <!-- <img src="../assets/images/company/info-button.svg" class="cursor-pointer" style="height: 11px; width: 11px;"> -->
                </div>
              </div>

              <div class="top-margin-20">
                <el-row>
                  <el-col
                    :xs="24"
                    :sm="24"
                    :md="24"
                    :lg="8"
                    :xl="8"
                    class="bottom-margin-15"
                  >
                    <div class="sub-title">Current Plan</div>
                    <div class="title">
                      StockAnts {{ getSubscribedPlanDetails.plan }}

                    </div>
                    <div
                      style="font-size: 0.8rem; color: #cccccc"
                      v-if="getSubscribedPlanDetails.plan_amount != 'NA'"
                    >
                      (Equity + Options)
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="6"
                    :xl="6"
                    class="text-center bottom-margin-20"
                  >
                    <div class="sub-title">Access Duration</div>
                    <div class="title">
                      {{
                        getSubscribedPlanDetails.days == 30
                          ? "30 days"
                          : getSubscribedPlanDetails.days == 3
                          ? "3 days"
                          : getSubscribedPlanDetails.days == 1
                          ? "24 hrs"
                          : getSubscribedPlanDetails.days == 7
                          ? "Week"
                          : `${getSubscribedPlanDetails.days} days`
                      }}
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="5"
                    :xl="5"
                    class="text-center bottom-margin-20"
                  >
                    <div class="sub-title">Expires on</div>
                    <div class="title">
                      {{
                        moment(getSubscribedPlanDetails.expire_date).format(
                          "DD MMM YYYY"
                        )
                      }}
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="5"
                    :xl="5"
                    class="text-center bottom-margin-15"
                  >
                    <div class="sub-title">Plan Price</div>
                    <div class="title">
                      {{
                        getSubscribedPlanDetails.plan_amount == "NA"
                          ? "NA"
                          : getSubscribedPlanDetails.plan_amount
                          ? "₹" +
                            Number(
                              getSubscribedPlanDetails.plan_amount
                            ).toFixed() +
                            "/-"
                          : "-"
                      }}
                      <div
                        style="font-size: 0.8rem; color: #cccccc"
                        v-if="getSubscribedPlanDetails.plan_amount != 'NA'"
                      >
                        (Incl of all taxes)
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>

          <el-card
            class="box-card"
            style="
              margin-top: -35px !important;
              border-radius: 0px 0px 10px 10px !important;
              border-top: 0.5px solid #afafaf;
            "
          >
            <el-collapse v-model="billing_details_collapse" accordion>
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="flex">
                    <img
                      src="../assets/images/myAccount/Subscribed Features Icon.svg"
                      style="width: 20px"
                    />
                    <div
                      class="label-md-bold-black left-margin-10"
                      style="color: #2d2e8d"
                    >
                      Subscribed Premium Features
                    </div>
                  </div>
                </template>
                <div class="flex feature" style="margin-top: 30px">
                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div
                      class="feature-title ellipsis"
                      style="min-width: 400px"
                    >
                      Equity & Options
                    </div>
                  </div>

                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div
                      class="feature-title ellipsis"
                      style="min-width: 400px"
                    >
                      Real Time Tracking of Advisory
                    </div>
                  </div>
                </div>

                <div class="flex feature" style="margin-top: 30px">
                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div
                      class="feature-title ellipsis"
                      style="min-width: 400px"
                    >
                      Bundle of SEBI Experts
                    </div>
                  </div>

                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div
                      class="feature-title ellipsis"
                      style="min-width: 400px"
                    >
                      Trade with your Broker
                    </div>
                  </div>
                </div>

                <div class="flex feature" style="margin-top: 30px">
                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div
                      class="feature-title ellipsis"
                      style="min-width: 400px"
                    >
                      Experts Performance Overview
                    </div>
                  </div>

                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div
                      class="feature-title ellipsis"
                      style="min-width: 400px"
                    >
                      Trading Cost Estimation
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-col>

        <!-- {{ getSubscribedPlanDetails }} -->

        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="5"
          :xl="5"
          v-if="
            websiteUserType.userType != 'broker' &&
              getSubscribedPlanDetails.access_code &&
              getSubscribedPlanDetails.access_code !== null
          "
        >
          <el-card class="box-card pro-card access-code" style="padding: 15px">
            <div class="access-code-section">
              <div class="head top-margin-10">Access Code</div>

              <div class="code-box head" id="access-code">
                <span id="access-code">
                  {{
                    getSubscribedPlanDetails.access_code
                      ? getSubscribedPlanDetails.access_code
                      : "-"
                  }}
                </span>
                <i
                  class="el-icon-copy-document left-margin-5 font-weight-600 cursor-pointer"
                  @click="copyTextToClipboard('access-code')"
                ></i>
              </div>

              <div
                class="top-margin-3 bottom-margin-3 font-06rem capitalize font-weight-500"
              >
                Use this code to get free access on broker login & trade
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-card
        class="box-card lite-card"
        v-if="
          (!Object.keys(getSubscribedPlanDetails).length ||
            getSubscribedPlanDetails.plan == 'Lite') &&
            !is_subscribed_plan_details_loading
        "
      >
        <div>
          <div class="flex-space-between">
            <div>
              <span
                class="label-xs-bold"
                style="font-weight: 600; font-size: 15px"
                >Subscribed Plan</span
              >
              &nbsp;
              <img
                src="../assets/images/company/info-button.svg"
                class="cursor-pointer"
                style="height: 11px; width: 11px"
              />
            </div>
          </div>

          <div class="top-margin-20">
            <el-row>
              <el-col
                :xs="24"
                :sm="24"
                :md="8"
                :lg="8"
                :xl="8"
                class="bottom-margin-15"
              >
                <div class="sub-title">You are subscribed to</div>
                <div class="title">
                  StockAnts {{ getSubscribedPlanDetails.plan }}
                </div>
              </el-col>

              <el-col
                :xs="12"
                :sm="12"
                :md="6"
                :lg="6"
                :xl="6"
                class="text-center bottom-margin-15"
              >
                <div class="sub-title">Billed Monthly</div>
                <div class="title">₹ 0</div>
              </el-col>

              <el-col
                :xs="12"
                :sm="12"
                :md="10"
                :lg="10"
                :xl="10"
                class="text-center bottom-margin-15"
              >
                <div class="sub-title">Expires on</div>
                <div class="title">
                  Lifetime
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>

      <el-card
        class="no-plan box-card"
        v-if="
          !Object.keys(getSubscribedPlanDetails).length &&
            currentEnvironment.loginModule == 'BlinkX'
        "
      >
        <div>
          <div class="flex-space-between">
            <div>
              <img
                src="../assets/images/plan1.png"
                style="width: 20px"
              />&nbsp;&nbsp;
              <span class="label-md-bold" style="color: #000; font-weight: 600"
                >Plan</span
              >
              &nbsp;
            </div>
          </div>

          <NoDataFound></NoDataFound>
        </div>
      </el-card>
      <div
        class="flex-space"
        style="background-color: #fcfcfc; padding: 10px !important; margin: 30px 0;"
        v-if="
          Object.keys(getPublisherPlanDetails).length &&
            getPublisherPlanDetails.plan == 'Publisher'
        "
      >
        <div class="flex">
          <img
            src="../assets/images/myAccount/Added Icon.svg"
            style="width: 18px; margin-left: 20px"
          />
          <div
            class="label-md-bold-black left-margin-10 font-weight-600"
            style="color: #000000"
          >
            Added Subscription
          </div>
        </div>
      </div>

      <!-- Below code for subscribed publisher features -->
      <el-row
        v-if="
          Object.keys(getPublisherPlanDetails).length &&
            getPublisherPlanDetails.plan == 'Publisher'
        "
      >
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="websiteUserType.userType != 'broker' ? 24 : 24"
          :xl="websiteUserType.userType != 'broker' ? 24 : 24"
        >
          <el-card
            class="box-card publisher-card"
            style="border-radius: 10px 10px 0px 0px !important; padding: 0px !important"
          >
            <div>
              <div
                class="flex-space-between"
                style="
                  color: #2d2e8d;
                  background-color: #dbebff;
                  padding: 10px;
                  margin-left: -20px;
                  margin-right: -20px;
                  margin-top: -20px;
                "
              >
                <div class="flex">
                  <div
                    class="label-md-bold-black left-margin-10"
                    style="color: #2d2e8d; background-color: #dbebff"
                  >
                    Subscribed Plan
                  </div>

                  <img
                    src="../assets/images/myAccount/Publisher Icon.svg"
                    style="width: 20px; padding-left: 5px"
                  />
                </div>
              </div>

              <div class="top-margin-20">
                <el-row style="background-color: #ffffff">
                  <el-col
                    :xs="24"
                    :sm="24"
                    :md="24"
                    :lg="8"
                    :xl="8"
                    class="bottom-margin-15"
                  >
                    <div class="sub-title">Current Plan</div>
                    <div class="title">
                      StockAnts {{ getPublisherPlanDetails.plan }}

                      <div
                        style="font-size: 0.8rem; color: #505050"
                        v-if="getPublisherPlanDetails.plan_amount != 'NA'"
                      >
                        (Equity + Options)
                      </div>
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="6"
                    :xl="6"
                    class="text-center bottom-margin-20"
                  >
                    <div class="sub-title">Access Duration</div>
                    <div class="title">
                      {{
                        getPublisherPlanDetails.days == 30
                          ? "30 days"
                          : getPublisherPlanDetails.days == 3
                          ? "3 days"
                          : getPublisherPlanDetails.days == 1
                          ? "24 hrs"
                          : getPublisherPlanDetails.days == 7
                          ? "Week"
                          : `${getPublisherPlanDetails.days} days`
                      }}
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="5"
                    :xl="5"
                    class="text-center bottom-margin-20"
                  >
                    <div class="sub-title">Expires on</div>
                    <div class="title">
                      {{
                        moment(getPublisherPlanDetails.expire_date).format(
                          "DD MMM YYYY"
                        )
                      }}
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="5"
                    :xl="5"
                    class="text-center bottom-margin-15"
                  >
                    <div class="sub-title">Plan Price</div>
                    <div class="title">
                      {{
                        getPublisherPlanDetails.plan_amount == "NA"
                          ? "NA"
                          : getPublisherPlanDetails.plan_amount
                          ? "₹" +
                            Number(
                              getPublisherPlanDetails.plan_amount
                            ).toFixed() +
                            "/-"
                          : "-"
                      }}
                      <div
                        style="font-size: 0.6rem"
                        v-if="getPublisherPlanDetails.plan_amount != 'NA'"
                      >
                        (Incl of all taxes)
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>

          <el-card
            class="box-card"
            style="
              margin-top: -20px !important;
              border-radius: 0px 0px 10px 10px !important;
              border-top: 0.3px solid #bbbbbb; margin-bottom:20px
            "
          >
            <el-collapse v-model="billing_collapse" accordion>
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="flex">
                    <img
                      src="../assets/images/myAccount/Subscribed Features Icon.svg"
                      style="width: 20px"
                    />
                    <div
                      class="label-md-bold-black left-margin-10"
                      style="color: #2d2e8d"
                    >
                      Subscribed Publisher Features
                    </div>
                  </div>
                </template>

                <div
                  class="flex-space-between flex-wrap feature"
                  style="margin-top: 15px"
                >
                  <div class="flex ">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div class="feature-title" style="margin: 5px 0;">
                      Equity & Options Publisher
                    </div>
                  </div>

                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div class="feature-title" style="margin: 5px 0;">
                      Publish unlimited recommendations
                    </div>
                  </div>

                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div class="feature-title" style="margin: 5px 0;">
                      Real time tracking of Advisory
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-col>
      </el-row>

      <el-row
        v-if="
          Object.keys(getChatPlanDetails).length &&
            getChatPlanDetails.plan == 'StockAnts Chat'
        "
      >
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="websiteUserType.userType != 'broker' ? 24 : 24"
          :xl="websiteUserType.userType != 'broker' ? 24 : 24"
        >
          <el-card
            class="box-card publisher-card"
            style="border-radius: 10px 10px 0px 0px !important; padding: 0px !important"
          >
            <div>
              <div
                class="flex-space-between"
                style="
                  color: #2d2e8d;
                  background-color: #dbebff;
                  padding: 10px;
                  margin-left: -20px;
                  margin-right: -20px;
                  margin-top: -20px;
                "
              >
                <div class="flex">
                  <div
                    class="label-md-bold-black left-margin-10"
                    style="color: #2d2e8d; background-color: #dbebff"
                  >
                    Subscribed Plan
                  </div>

                  <img
                    src="../assets/images/ChatImages/Navy Blue Chat Icon.svg"
                    style="width: 20px; padding-left: 5px"
                  />
                </div>
              </div>

              <div class="top-margin-20">
                <el-row style="background-color: #ffffff">
                  <el-col
                    :xs="24"
                    :sm="24"
                    :md="24"
                    :lg="8"
                    :xl="8"
                    class="bottom-margin-15"
                  >
                    <div class="sub-title">Current Plan</div>
                    <div class="title">
                      {{ getChatPlanDetails.plan }}
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="6"
                    :xl="6"
                    class="text-center bottom-margin-20"
                  >
                    <div class="sub-title">Access Duration</div>
                    <div class="title">{{ getChatPlanDetails.days }} days</div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="5"
                    :xl="5"
                    class="text-center bottom-margin-20"
                  >
                    <div class="sub-title">Expires on</div>
                    <div class="title">
                      {{
                        moment(getChatPlanDetails.expire_date).format(
                          "DD MMM YYYY"
                        )
                      }}
                    </div>
                  </el-col>

                  <el-col
                    :xs="24"
                    :sm="8"
                    :md="8"
                    :lg="5"
                    :xl="5"
                    class="text-center bottom-margin-15"
                  >
                    <div class="sub-title">Plan Price</div>
                    <div class="title">
                      {{
                        getChatPlanDetails.plan_amount == "NA"
                          ? "NA"
                          : getChatPlanDetails.plan_amount
                          ? "₹" +
                            Number(getChatPlanDetails.plan_amount).toFixed() +
                            "/-"
                          : "-"
                      }}
                      <div
                        style="font-size: 0.6rem"
                        v-if="getChatPlanDetails.plan_amount != 'NA'"
                      >
                        (Incl of all taxes)
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>

          <el-card
            class="box-card"
            style="
              margin-top: -20px !important;
              border-radius: 0px 0px 10px 10px !important;
              border-top: 0.3px solid #bbbbbb; margin-bottom:20px
            "
          >
            <el-collapse v-model="billing_collapse" accordion>
              <el-collapse-item name="2">
                <template slot="title">
                  <div class="flex">
                    <img
                      src="../assets/images/myAccount/Subscribed Features Icon.svg"
                      style="width: 20px"
                    />
                    <div
                      class="label-md-bold-black left-margin-10"
                      style="color: #2d2e8d"
                    >
                      Subscribed Chat Features
                    </div>
                  </div>
                </template>

                <div
                  class="flex-space-between flex-wrap feature"
                  style="margin-top: 15px"
                >
                  <div class="flex ">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div class="feature-title" style="margin: 5px 0;">
                      Exclusive 15 mins Session
                    </div>
                  </div>

                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div class="feature-title" style="margin: 5px 0;">
                      Real-Time personalize Financial Guidance
                    </div>
                  </div>

                  <div class="flex">
                    <img
                      src="../assets/images/Tick Icon.svg"
                      alt=""
                      class="right-margin-10"
                    />
                    <div class="feature-title" style="margin: 5px 0;">
                      Instant Validation of Investment Idea
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import moment from "moment";
import { EventBus } from "../eventBus";
import CripNotice from "crip-vue-notice";
import { HelperNetworkCallBack } from "../mixins/Helper";
import NoDataFound from "../components/NoDataFound.vue";

export default {
  name: "PlanDetails",
  mixins: [HelperNetworkCallBack],
  components: { NoDataFound },
  data() {
    return {
      is_subscribed_plan_details_loading: false,
      billing_details_collapse: "",
      billing_collapse: "",
      moment: moment,
      websiteUserType: localStorage.getItem("websiteUserType")
        ? JSON.parse(localStorage.getItem("websiteUserType"))
        : {},
      currentEnvironment: localStorage.getItem("currentEnvironment")
        ? JSON.parse(localStorage.getItem("currentEnvironment"))
        : {},
    };
  },

  mounted() {
    if (
      !Object.keys(this.getSubscribedPlanDetails).length ||
      !Object.keys(this.getPublisherPlanDetails).length
    ) {
      this.getPlanDetails();
    }
  },

  methods: {
    getPlanDetails() {
      this.is_subscribed_plan_details_loading = true; //enabled loader

      serverAddr
        .post("/stockants_pro/get-user-subscription/", {})
        .then((response) => {
          if (response.data.status) {
            // Separate Premium and Publisher plans
            var premiumPlan = response.data.data.find(
              (plan) => plan.plan === "Premium" || plan.plan === "Lite"
            );

            var publisherPlans = response.data.data.find(
              (plan) => plan.plan === "Publisher"
            );
            publisherPlans = publisherPlans ? publisherPlans : {};

            var stockAntsChatPlan = response.data.data.find(
              (plan) => plan.plan === "StockAnts Chat"
            );
            stockAntsChatPlan = stockAntsChatPlan ? stockAntsChatPlan : {};

            // Save Premium plan details
            if (premiumPlan) {
              this.$store.commit("commitSubscribedPlanDetails", premiumPlan);
              this.saveSubscribedPlanDetailsToLocalStorage(premiumPlan);
            }

            // Save Publisher plan details
            this.$store.commit("commitPublisherPlanDetails", publisherPlans);
            this.saveSubscribedPublisherPlanDetails(publisherPlans);

            // Save Publisher plan details
            this.$store.commit("commitChatPlanDetails", stockAntsChatPlan);
            this.saveSubscribedChatPlanDetails(stockAntsChatPlan);
          }

          this.is_subscribed_plan_details_loading = false; //disabled loader
        })
        .catch((error) => {
          console.log(error);
          this.is_subscribed_plan_details_loading = false; //disabled loader
        });
    },
    copyTextToClipboard(elementId) {
      var element = document.getElementById(elementId);
      if (element) {
        var textToCopy = element.textContent.trim();
        if (textToCopy) {
          navigator.clipboard
            .writeText(textToCopy)
            .then(
              () =>
                new CripNotice({
                  title: "Success",
                  description: "Access code copied.",
                  type: "success",
                  duration: 2,
                })
            )
            .catch((err) => console.error("Copy failed: ", err));
        } else {
          console.warn("Text is empty after trimming whitespace");
        }
      } else {
        console.error("Element with ID '" + elementId + "' not found");
      }
    },
  },

  computed: {
    getSubscribedPlanDetails() {
      return this.$store.state.subscribed_plan_details;
    },
    getPublisherPlanDetails() {
      return this.$store.state.publisher_plan_details;
    },
    getChatPlanDetails() {
      return this.$store.state.chat_plan_details;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.PlanDetails {
  .NoDataFound {
    padding: 0;
  }
  .plan-details-container {
    .pro-card {
      background: rgb(30, 48, 209);
      background: linear-gradient(
        180deg,
        rgba(30, 48, 209, 1) 7%,
        rgba(43, 44, 211, 1) 17%,
        rgba(48, 50, 159, 1) 47%,
        rgba(40, 41, 158, 1) 59%
      );
      min-height: 180px;

      .title {
        line-height: 1.3;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
      }

      .sub-title {
        color: #fff;
        font-size: 11px;
        font-weight: 500;
        margin-bottom: 2px;
      }
    }

    .publisher-card {
      // background-color: #DBEBFF;
      // min-height: 180px;

      .title {
        line-height: 1.3;
        color: rgb(45, 46, 141);
        font-size: 18px;
        font-weight: 600;
      }

      .download {
        margin: 30px 20px 30px 20px;
        border-radius: 10px;
        padding: 10px;
        text-align: center;
        background-color: #d0d0d0;
        color: #ffffff;
      }
      .sub-title {
        color: rgb(45, 46, 141);
        font-size: 11px;
        font-weight: 500;
        margin-bottom: 2px;
      }
    }

    .access-code-section {
      color: #ffff;
      text-align: center;
      .code-box {
        border: 1px dashed #000;
        padding: 7px 10px;
        border-radius: 5px;
        margin: 10px auto;
        background-color: #ffff;
        color: #000;
        // min-width: 130px;
      }

      .head {
        font-size: 13px;
        font-weight: 600;
      }
    }
    .lite-card {
      background-image: url("../assets/images/myAccount/premium_bg.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      .title {
        line-height: 1.3;
        color: #000;
        font-size: 18px;
        font-weight: 600;
      }

      .sub-title {
        color: #000;
        font-size: 11px;
        font-weight: 500;
        margin-bottom: 2px;
      }
    }
    color: #000;
    border-radius: 4px;
    .wallet-icon {
      color: $secondary-theme-color;
      font-size: 20px;
    }

    .add-btn {
      background-color: transparent;
      color: $primary-theme-color;
      border-color: $primary-theme-color;
      width: 100px;
      // font-weight: 500;
      font-size: 12px;
      line-height: 1px;
      border-radius: 50px;
    }
    .add-btn:hover {
      color: #fff;
      background-color: $primary-theme-color;
    }
  }
}
.PlanDetails .btn-gradient {
  background-image: linear-gradient(to left, #dc6250, #eb5151);
  outline: none;
  border-radius: 25px;
  height: 25px;
  line-height: 1.5px;
  color: #fff;
  font-size: 13px;
  border: none;
  cursor: pointer;
}

.PlanDetails .payment-success-dialog {
  .modal-content {
    .dailog-bg {
      background: $secondary-theme-color;
      background-repeat: no-repeat;
      background-position: center center;
      height: 100px;
      padding: 20px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .cancel-sub-success-dialog-bg {
      background: $secondary-theme-color;
      background-repeat: no-repeat;
      background-position: center center;
      height: 160px;
      padding: 20px;
      border-radius: 10px;
    }
    .dialog-decp {
      display: block !important;
    }

    .plan-details-section {
      .title {
        font-size: 0.9rem;
        color: #fff;
        font-weight: 600;
      }
      .sub-title {
        font-weight: 600;
        font-size: 0.7rem;
        color: #fff;
      }
      .first-col {
        text-align: left;
      }
      .second-col {
        text-align: right;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .modal-content .dailog-bg {
      height: 140px !important;
    }
  }
}
@media screen and (max-width: 600px) {
  /* For screens smaller than 600px wide */
  #certificateContainer {
    width: 95vw; /* Set the width to 95% of the viewport width */
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  /* For screens between 601px and 1024px wide */
  #certificateContainer {
    width: 80vw; /* Set the width to 80% of the viewport width */
  }
}

@media screen and (min-width: 1025px) {
  /* For screens larger than 1024px wide */
  #certificateContainer {
    width: 60vw; /* Set the width to 60% of the viewport width */
  }
}
</style>

<style lang="scss">
.PlanDetails {
  .access-code {
    .el-card__body {
      padding: 20px 0;
    }
  }
}
</style>
